"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signChallengeActInfoApi = signChallengeActInfoApi;
exports.signChallengeActInfoStatisticsApi = signChallengeActInfoStatisticsApi;
exports.signChallengeCreateApi = signChallengeCreateApi;
exports.signChallengeDeleteApi = signChallengeDeleteApi;
exports.signChallengeDetailApi = signChallengeDetailApi;
exports.signChallengeListApi = signChallengeListApi;
exports.signChallengeRecordApi = signChallengeRecordApi;
exports.signChallengeRecordUserTaskRecordApi = signChallengeRecordUserTaskRecordApi;
exports.signChallengeUpdateApi = signChallengeUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 打卡活动列表
 * @param params
 */
function signChallengeListApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/signChallenge/activity/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增打卡活动
 * @param data
 */
function signChallengeCreateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/signChallenge/activity/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑打卡活动
 * @param data
 */
function signChallengeUpdateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/signChallenge/activity/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除打卡活动
 */
function signChallengeDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/platform/signChallenge/activity/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 打卡活动详情
 * @param id
 */
function signChallengeDetailApi(id) {
  return (0, _request.default)({
    url: "admin/platform/signChallenge/activity/detail",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 打卡活动活动数据统计
 * @param data
 */
function signChallengeActInfoStatisticsApi(data) {
  return (0, _request.default)({
    url: "admin/platform/signChallenge/activity/statistics/total",
    method: 'GET',
    params: data
  });
}

/**
 * 打卡活动活动数据
 * @param data
 */
function signChallengeActInfoApi(data) {
  return (0, _request.default)({
    url: "admin/platform/signChallenge/activity/statistics/list",
    method: 'GET',
    params: data
  });
}

/**
 * 打卡活动打卡明细
 * @param data
 */
function signChallengeRecordApi(data) {
  return (0, _request.default)({
    url: "admin/platform/signChallenge/activity/dailyDetail/list",
    method: 'GET',
    params: data
  });
}

/**
 * 打卡活动打卡明细用户任务完成情况
 * @param data
 */
function signChallengeRecordUserTaskRecordApi(data) {
  return (0, _request.default)({
    url: "admin/platform/signChallenge/activity/dailyDetail/taskCompletion",
    method: 'GET',
    params: data
  });
}